import {
  LOG_OUT,
  GET_ADMIN_WHOLE_VENDOR_DINER,
  GET_ADMIN_WHOLE_PENDING_DINER,
  GET_ADMIN_WHOLE_RESERVATION_DINER,
  GET_ADMIN_WHOLE_RESERVATION_TIMING_SLOTS,
  GET_ADMIN_WHOLE_HISTORY_DINER,
  SET_ADMIN_WHOLE_DINER_DETAILS,
  SET_ADMIN_WHOLE_VENDOR_TICKETS_USER_DETAILS,
  INC_ADMIN_WHOLE_SEATING_COUNT,
  DEC_ADMIN_WHOLE_SEATING_COUNT,
} from "../../types";

const initialState = {
  vendor_all_diner: { total: 0, limit: 10, skip: 0, data: [] },
  vendor_all_pending_diner: { total: 0, limit: 10, skip: 0, data: [] },
  vendor_all_reservation_diner: { total: 0, limit: 10, skip: 0, data: [] },
  vendor_all_history_diner: { total: 0, limit: 10, skip: 0, data: "" },
  get_vendor_reservation_timing_slots: [],
  diner_Details: [],
  set_vendor_tickets_user_details: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ADMIN_WHOLE_VENDOR_DINER:
      return {
        ...state,
        vendor_all_diner: action.payload,
      };
    case GET_ADMIN_WHOLE_PENDING_DINER:
      return {
        ...state,
        vendor_all_pending_diner: action.payload,
      };
    case GET_ADMIN_WHOLE_RESERVATION_DINER:
      return {
        ...state,
        vendor_all_reservation_diner: action.payload,
      };
    case GET_ADMIN_WHOLE_HISTORY_DINER:
      return {
        ...state,
        vendor_all_history_diner: action.payload,
      };
    case GET_ADMIN_WHOLE_RESERVATION_TIMING_SLOTS:
      return {
        ...state,
        get_vendor_reservation_timing_slots: action.payload,
      };
    case SET_ADMIN_WHOLE_DINER_DETAILS:
      return {
        ...state,
        diner_Details: action.payload,
      };
    case SET_ADMIN_WHOLE_VENDOR_TICKETS_USER_DETAILS:
      return {
        ...state,
        set_vendor_tickets_user_details: action.payload,
      };
    case INC_ADMIN_WHOLE_SEATING_COUNT:
      return {
        ...state,
        vendor_all_diner: {
          ...state.vendor_all_diner,
          total: state.vendor_all_diner.total + 1,
        },
      };
    case DEC_ADMIN_WHOLE_SEATING_COUNT:
      return {
        ...state,
        vendor_all_diner: {
          ...state.vendor_all_diner,
          total: state.vendor_all_diner.total - 1,
        },
      };
    case LOG_OUT: {
      return {
        ...state,
        vendor_all_diner: { total: 0, limit: 10, skip: 0, data: [] },
        vendor_all_pending_diner: { total: 0, limit: 10, skip: 0, data: [] },
        vendor_all_reservation_diner: {
          total: 0,
          limit: 10,
          skip: 0,
          data: [],
        },
        vendor_all_history_diner: { total: 0, limit: 10, skip: 0, data: "" },
        get_vendor_reservation_timing_slots: [],
        diner_Details: [],
        set_vendor_tickets_user_details: [],
      };
    }
    default:
      return state;
  }
}
